import React from 'react'
import isEmpty from 'lodash/isEmpty'
import { useTranslation } from 'react-i18next'
import { Box } from '@mui/material'
import InstagramIcon from '@mui/icons-material/Instagram'
import FacebookIcon from '@mui/icons-material/Facebook'
import LanguageIcon from '@mui/icons-material/Language'
import { SocialMediaLink } from './components/SocialMediaLink/SocialMediaLink'
import { useGeneralConfiguration } from '../../../features/Configuration/GeneralConfiguration/hooks/useGeneralConfiguration'
import { LeftContentWrapper, LinkContainer, LogoImage, TextLink } from './FooterLeftContent.styled'
import { FooterSeparator } from '../Footer.styled'
import { StaticPages } from '../../../pages/StaticPage/types'
import { CustomerRoutes } from '../../../config/routes.config'

const footerStaticPages = [
  { page: StaticPages.CONTACT, path: CustomerRoutes.CONTACT },
  { page: StaticPages.SERVICES, path: CustomerRoutes.SERVICES },
  { page: StaticPages.PRICELIST, path: CustomerRoutes.PRICELIST },
  { page: StaticPages.RESERVATION_POLICY, path: CustomerRoutes.RESERVATION_POLICY },
  { page: StaticPages.PRIVACY_POLICY, path: CustomerRoutes.PRIVACY_POLICY },
] as const

const FooterLeftContent: React.FC = () => {
  const { logo, instaUrl, facebookUrl, websiteUrl } = useGeneralConfiguration()
  const { t } = useTranslation()

  return (
    <LeftContentWrapper>
      {/* ----------------------- Logo ----------------------- */}
      <LogoImage alt="Logo" src={logo} />

      {/* ----------------------- Links ----------------------- */}
      <LinkContainer>
        {!isEmpty(footerStaticPages) &&
          footerStaticPages.map(({ page, path }, index, array) => {
            const isNotLastItem = index < array.length - 1 // Extract condition for clarity

            return (
              <React.Fragment key={index}>
                <TextLink href={path} underline="none">
                  {t(`footer.links.${page}`)}
                </TextLink>
                {isNotLastItem && <FooterSeparator orientation="vertical" flexItem />}
              </React.Fragment>
            )
          })}
      </LinkContainer>

      {/* ----------------------- Social Media Links ----------------------- */}
      <Box sx={{ display: 'flex', marginTop: '20px' }}>
        <SocialMediaLink href={instaUrl} Icon={InstagramIcon} />
        <SocialMediaLink href={facebookUrl} Icon={FacebookIcon} />
        <SocialMediaLink href={websiteUrl} Icon={LanguageIcon} />
      </Box>
    </LeftContentWrapper>
  )
}

export default FooterLeftContent
